import { Box, Button, ClickAwayListener, Paper, Popper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useState, useRef } from "react";
import { makeStyles } from "tss-react/mui";
import PlanningPanel from "./PlanningPanel";
import { Defaults, useEntityField } from "@emberly/zenith-client";
import { TaskEnums } from "../../../../../../common/constants";
import { FullTimeView, TimeView } from "../../../../../common/core/Time";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative",
      borderRadius: theme.spacing(1),
      paddingRight: theme.spacing(0.5),
      paddingLeft: theme.spacing(1.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      background: theme.palette.background.grey,
      width: "100%",
      height: "auto"
    },
    titleContainer: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(0.5)
    },
    titleText: {
      lineHeight: "100%"
    },
    textValue: {
      lineHeight: "100%"
    },
    button: {
      borderRadius: theme.spacing(1)
    },
    popper: {
      zIndex: 1000
    },
    paper: {
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2)
    }
  })
);


export default function PlanningPopper(props) {
  const { path } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();

  const plannedType = useEntityField(`${path}.plannedType`, Defaults.Enum);
  const plannedStart = useEntityField(`${path}.plannedStart`, Defaults.String);
  const plannedEnd = useEntityField(`${path}.plannedEnd`, Defaults.String);

  const rootEl = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [width, setWidth] = useState(0);

  const onOpen = useCallback((ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    setOpen(v => !v);
    if (!!rootEl.current) {
      setWidth(rootEl.current.clientWidth);
      setAnchorEl(rootEl.current);
    }
  }, []);

  return (
    <>
      <Box className={classes.root} ref={rootEl}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" >
          <Stack direction="column" className={classes.titleContainer}>
            <Typography variant="caption" className={classes.titleText} color="textSecondary">
              {t("mission:cards:tasks:planning:label")}
            </Typography>
            <Typography variant="body1" className={classes.titleValue} color="textPrimary">
              {
                plannedType.value === TaskEnums.PlanningType.Interval ? (
                  <>
                    {t("mission:cards:tasks:planning:from")} <TimeView time={plannedStart.value} /><br />
                    {t("mission:cards:tasks:planning:to")} <TimeView time={plannedEnd.value} />
                  </>
                ) : plannedType.value === TaskEnums.PlanningType.Time ? (
                  <FullTimeView time={plannedEnd.value} />
                ) : (
                  t("task:enums:planningType:None")
                )
              }
            </Typography>
          </Stack>
          <Button color="info" onClick={onOpen}>Endre</Button>
        </Stack>
      </Box>

      <Popper
        className={classes.popper}
        open={open}
        anchorEl={anchorEl}
        placement="bottom"
      >
        <ClickAwayListener onClickAway={onOpen}>
          <Paper elevation={3} sx={{ width }} className={classes.paper}>
            <PlanningPanel
              plannedType={plannedType}
              plannedStart={plannedStart}
              plannedEnd={plannedEnd}
            />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}

